import React from "react";

export const SET_DATE_RANGE = "locale/visitors/filters/SET_DATE_RANGE";
export const SET_SEARCH_TEXT = "locale/visitors/filters/SET_SEARCH_TEXT";
export const SET_FILTER = "locale/visitors/filters/SET_FILTER";
export const CLEAR_ALL_FILTER_SETTINGS = "locale/visitors/filters/CLEAR_FILTER_SETTINGS";

export const setDateRange = (page, startDate, endDate, dontReload) => ({
    type: `${page}_${SET_DATE_RANGE}`,
    payload: {
        startDate: startDate,
        endDate: endDate,
        dontReload: dontReload,
    }
})

export const setSearchText = (page, value, dontReload) => ({
    type: `${page}_${SET_SEARCH_TEXT}`,
    payload: {
        value: value,
        dontReload: dontReload
    }
})

export const setFilter = (page, value, dontReload) => ({
    type: `${page}_${SET_FILTER}`,
    payload: {
        value: value,
        dontReload: dontReload,
    }
})

export const clearFilterSettings = (page, dontReload) => ({
    type: `${page}_${CLEAR_ALL_FILTER_SETTINGS}`,
    payload: {
        dontReload: dontReload,
    }
})

export const initialState = {
    dateRangeStart: false,
    dateRangeEnd: false,
    searchText: '',
    filter: [],
    filterUpdateCount: 0,
};

export const filtersReducerFor = (page) => {
    return (state = initialState, action) => {
        //console.log(`${page}_${action.type}`, action.payload);

        switch (action.type) {
            case `${page}_${SET_DATE_RANGE}`: {
                return {
                    ...state,
                    dateRangeStart: action.payload.startDate,
                    dateRangeEnd: action.payload.endDate,
                    filterUpdateCount: state.filterUpdateCount + ((action.payload.dontReload) ? 0 : 1)
                }
            }

            case `${page}_${SET_SEARCH_TEXT}`: {
                return {
                    ...state,
                    searchText: action.payload.value,
                    filterUpdateCount: state.filterUpdateCount + ((action.payload.dontReload) ? 0 : 1)
                }
            }

            case `${page}_${SET_FILTER}`: {
                return {
                    ...state,
                    filter: action.payload.value,
                    filterUpdateCount: state.filterUpdateCount + ((action.payload.dontReload) ? 0 : 1)
                }
            }

            case `${page}_${CLEAR_ALL_FILTER_SETTINGS}`: {
                return {
                    ...state,
                    dateRangeStart: false,
                    dateRangeEnd: false,
                    filter: [],
                    filterUpdateCount: state.filterUpdateCount + ((action.payload.dontReload) ? 0 : 1),
                    searchText: '',
                }
            }

            default:
                return state;
        }
    }
}
